export const StaticDisplayText = {
	COPYRIGHTS: '© 2025 Inspire X70 HR Management System. ',
	POWERED_BY: <>Powered by <a className="poweredByLink" href="https://www.applab.com.my/" target="_blank">App Lab</a></>,
	APP_NAME: (process.env.REACT_APP_NAME || 'Inspire X70') + " " + (process.env.REACT_APP_HEADER || 'HR Management System'),
	APP_HEADER: process.env.REACT_APP_HEADER,
	APP_VERSION: process.env.REACT_APP_VERSION,
	COMPANY_NAME: 'App Lab',
	COMPANY_REGISTRATION_NO: '1215572-W',
	COMPANY_SSM_NO: '201701001422',
	COMPANY_ADDRESS: 'Lot 1F-11, Ground, Tower 5, Puchong Financial Corporate Centre, Jalan Puteri 1/2, Bandar Puteri, 47100 Puchong, Selangor, Malaysia',
	COMPANY_CONTACT: '03-8601 8064',
	VERSION_NUM: 'Version ' + (process.env.REACT_APP_VERSION || "--"),

	COMING_SOON: 'Coming Soon',
	UNDER_DEVELOPMENT: 'This page is under development',

	BASE_ON_SELECTED: 'Based on selected employees, modules & storage',
	UP_TO_TOTAL: 'Up to total ',
	GB_STORAGE_FOR: ' GB storage for files and databases',
}